"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createContext;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _QueuedUtterance = _interopRequireDefault(require("./QueuedUtterance"));

function createContext(_ref) {
  var speechSynthesis = _ref.speechSynthesis,
      SpeechSynthesisUtterance = _ref.SpeechSynthesisUtterance;
  var ponyfill = {
    speechSynthesis: speechSynthesis,
    SpeechSynthesisUtterance: SpeechSynthesisUtterance
  };
  var queueWithCurrent = [];
  var running;

  var run =
  /*#__PURE__*/
  function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!running) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              running = true;
              _context2.prev = 3;
              return _context2.delegateYield(
              /*#__PURE__*/
              _regenerator["default"].mark(function _callee() {
                var utterance;
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!(utterance = queueWithCurrent[0])) {
                          _context.next = 12;
                          break;
                        }

                        _context.prev = 1;
                        _context.next = 4;
                        return utterance.speak(ponyfill);

                      case 4:
                        _context.next = 9;
                        break;

                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](1); // TODO: If the error is due to Safari restriction on user touch
                        //       The next loop on the next audio will also fail because it was not queued with a user touch

                        _context.t0.message !== 'cancelled' && console.error(_context.t0);

                      case 9:
                        queueWithCurrent = queueWithCurrent.filter(function (target) {
                          return target !== utterance;
                        });
                        _context.next = 0;
                        break;

                      case 12:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[1, 6]]);
              })(), "t0", 5);

            case 5:
              _context2.prev = 5;
              running = false;
              return _context2.finish(5);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3,, 5, 8]]);
    }));

    return function run() {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    cancel: function () {
      var _cancel = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(id) {
        var index;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                index = queueWithCurrent.findIndex(function (utterance) {
                  return utterance.id === id;
                }); // We would leave the cancelled utterance in the queue because we want to reject the promise.

                _context3.next = 3;
                return queueWithCurrent[index].cancel();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function cancel(_x) {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }(),
    setPonyfill: function setPonyfill(_ref3) {
      var speechSynthesis = _ref3.speechSynthesis,
          SpeechSynthesisUtterance = _ref3.SpeechSynthesisUtterance;
      ponyfill = {
        speechSynthesis: speechSynthesis,
        SpeechSynthesisUtterance: SpeechSynthesisUtterance
      };
    },
    speak: function speak(utteranceLike) {
      // console.debug(`QUEUED: ${ utteranceLike.text }`);
      if (utteranceLike.id && queueWithCurrent.find(function (_ref4) {
        var id = _ref4.id;
        return id === utteranceLike.id;
      })) {
        // Do not queue duplicated speak with same unique ID
        // console.debug('NOT QUEUEING DUPE');
        return Promise.reject(new Error('Utterance with same ID is queued'));
      }

      var utterance = new _QueuedUtterance["default"](utteranceLike);
      queueWithCurrent = [].concat((0, _toConsumableArray2["default"])(queueWithCurrent), [utterance]);
      run();
      return utterance.promise;
    }
  };
}